// API Service for CommfluentBiz

const API_BASE = process.env.REACT_APP_BACKEND_URL;

// Generate or retrieve session ID for analytics
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('cfb_session_id');
  if (!sessionId) {
    sessionId = 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    sessionStorage.setItem('cfb_session_id', sessionId);
  }
  return sessionId;
};

// ============ Content API ============

export const fetchAllContent = async () => {
  try {
    const response = await fetch(`${API_BASE}/api/content`);
    if (!response.ok) throw new Error('Failed to fetch content');
    return await response.json();
  } catch (error) {
    console.error('Error fetching content:', error);
    return null;
  }
};

export const fetchContentByType = async (contentType) => {
  try {
    const response = await fetch(`${API_BASE}/api/content/${contentType}`);
    if (!response.ok) throw new Error(`Failed to fetch ${contentType}`);
    return await response.json();
  } catch (error) {
    console.error(`Error fetching ${contentType}:`, error);
    return null;
  }
};

// ============ Contact Form API ============

export const submitContactForm = async (formData) => {
  try {
    const response = await fetch(`${API_BASE}/api/contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to submit form');
    }
    
    return { success: true, data: await response.json() };
  } catch (error) {
    console.error('Error submitting contact form:', error);
    return { success: false, error: error.message };
  }
};

// ============ Analytics API ============

export const trackPageView = async (page) => {
  try {
    await fetch(`${API_BASE}/api/analytics/pageview`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        page,
        referrer: document.referrer || null,
        session_id: getSessionId(),
      }),
    });
  } catch (error) {
    // Silent fail for analytics
    console.debug('Analytics pageview error:', error);
  }
};

export const trackButtonClick = async (buttonId, buttonLabel, page = '/') => {
  try {
    await fetch(`${API_BASE}/api/analytics/click`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        button_id: buttonId,
        button_label: buttonLabel,
        page,
        session_id: getSessionId(),
      }),
    });
  } catch (error) {
    console.debug('Analytics click error:', error);
  }
};

export const trackSectionView = async (sectionId, timeSpentSeconds = null) => {
  try {
    await fetch(`${API_BASE}/api/analytics/section`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        section_id: sectionId,
        time_spent_seconds: timeSpentSeconds,
        session_id: getSessionId(),
      }),
    });
  } catch (error) {
    console.debug('Analytics section error:', error);
  }
};

export const fetchAnalyticsSummary = async () => {
  try {
    const response = await fetch(`${API_BASE}/api/analytics/summary`);
    if (!response.ok) throw new Error('Failed to fetch analytics');
    return await response.json();
  } catch (error) {
    console.error('Error fetching analytics:', error);
    return null;
  }
};
